/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PopupDto } from '../../models/popup-dto';

export interface PopupAdminControllerFindAllV1$Params {
}

export function popupAdminControllerFindAllV1(http: HttpClient, rootUrl: string, params?: PopupAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
  const rb = new RequestBuilder(rootUrl, popupAdminControllerFindAllV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PopupDto>>;
    })
  );
}

popupAdminControllerFindAllV1.PATH = '/api/v1/popups/admin/all';
